import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate, useParams } from 'react-router-dom';

import axios from 'axios';

const UserRank = ({ token ,onClose}) => {
    const [users, setUsers] = useState([]);
    const navigate = useNavigate();

    const fetchUsers = async () => {
        try {
            const response = await axios.get('/users/rank', {
                headers: { Authorization: `Bearer ${token}` },
            });
            const data = response.data
            setUsers(data.users);
        } catch (error) {
            alert('사용자 목록을 가져오는데 실패했습니다');
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    // return (
    //     <div>
    //         <h3>User Rank</h3>
    //         <ul>
    //             {users.map((user) => (
    //                 <li key={user.username}>
    //                     {user.username} 
    //                     해 높이 : {user.newYearSun.gauge}
    //                     <img src={`/assets/character/${user.avatar}`} alt="Avatar" />
    //                     <button onClick={() => navigate(`/userSun/${user.uuid}`)}>해 보러가기</button>
    //                 </li>
    //             ))}
    //         </ul>
    //     </div>
    // );
    // return (
    //     <div className="leaderboard">
    //       <h3 className="leaderboard-title">User Rank</h3>
    //       <ul className="leaderboard-list">
    //         {users.map((user) => (
    //           <li key={user.username} className="leaderboard-item">
    //             <div className="leaderboard-user">
    //               <img
    //                 src={`/assets/character/${user.avatar}`}
    //                 alt="Avatar"
    //                 className="leaderboard-avatar"
    //               />
    //               <div className="leaderboard-info">
    //                 <p className="leaderboard-username">{user.username}</p>
    //                 <p className="leaderboard-gauge">
    //                   해 높이: <span>{user.newYearSun.gauge}</span>
    //                 </p>
    //               </div>
    //             </div>
    //             <button
    //               className="leaderboard-button"
    //               onClick={() => navigate(`/userSun/${user.uuid}`)}
    //             >
    //               해 보러가기
    //             </button>
    //           </li>
    //         ))}
    //       </ul>
    //     </div>
    //   );

    return (
      <div className="leaderboard">
        <h3 className="leaderboard-title">User Rank</h3>
        <table className="leaderboard-table">
          <thead>
            <tr>
              <th>랭킹</th>
              {/* <th>아바타</th> */}
              <th>사용자 이름</th>
              <th>해 높이</th>
              <th>해 보러가기</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => (
              <tr key={user.username} className="leaderboard-row">
                <td>{index + 1}</td>
                {/* <td>
                  <img
                    src={`/assets/character/${user.avatar}`}
                    alt="Avatar"
                    className="leaderboard-avatar"
                  />
                </td> */}
                <td>{user.username}</td>
                <td>{user.newYearSun.gauge}</td>
                <td>
                  <button
                    className="leaderboard-button"
                    onClick={() => {
                      navigate(`/userSun/${user.uuid}`)
                      onClose()
                    }}
                  >
                    해 보러가기
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
};

export default UserRank;